import { ChangeDetectionStrategy, Component, HostBinding, OnInit, computed, input } from '@angular/core';

import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Decimal } from 'decimal.js';
import { Observable, debounce, map, timer } from 'rxjs';

import { AccaBoostSummary, AccaBoostSummaryService } from '../../../services/acca-boost-summary.service';

interface ViewModel {
    stake: Decimal | null;
    winnings: Decimal | null;
    boostedWinnings: Decimal | null;
}

@Component({
    selector: 'bs-acca-boost-winnings',
    templateUrl: './acca-boost-winnings.component.html',
    styleUrls: ['./acca-boost-winnings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostWinningsComponent implements OnInit {
    pickCount = input<number>();

    readonly isEnhancedLayoutEnabled = this.accaConfig.isEnhancedLayoutEnabled;

    accaBoostTitleIconSize: string;
    accaBoostIcon: { name: string; size: string };

    @HostBinding('class') className = 'acca-boost-module acca-boost-winnings';

    summary$: Observable<ViewModel>;

    returnsMessage = computed(() => {
        return this.getReturnsMessage(this.pickCount());
    });

    constructor(
        public sitecore: Sitecore,
        private summaryService: AccaBoostSummaryService,
        private accaConfig: AccaBoostConfig,
    ) {}

    ngOnInit(): void {
        const source$ = this.summaryService.getSummary$();
        this.accaBoostIcon = {
            name: this.accaConfig.icon,
            size: this.accaConfig.accaBoostInfoVersion === 'V2' ? '12' : '14',
        };

        this.accaBoostTitleIconSize = this.isEnhancedLayoutEnabled ? '16' : this.accaBoostIcon.size;

        this.summary$ = source$.pipe(
            debounce((value) => (value === null ? timer(500) : timer(0))), // postpone the empty winnings not to show it on leave animation
            map((summary) => this.mapSummary(summary)),
        );
    }

    private mapSummary(summary: AccaBoostSummary | null): ViewModel {
        const winnings = summary?.originalWinningsNet || summary?.originalWinnings || null;
        const boosteWinnings = summary?.boostedWinningsNet || summary?.boostedWinnings || null;

        return {
            stake: summary?.stake || null,
            winnings: winnings?.isZero() ? null : winnings,
            boostedWinnings: boosteWinnings?.isZero() ? null : boosteWinnings,
        };
    }

    getReturnsMessage(pickCount: number | undefined): string {
        switch (pickCount) {
            case 2:
                return this.sitecore.betslip.betslipBar.Double;
            case 3:
                return this.sitecore.betslip.betslipBar.Treble;
            default:
                return pickCount + ' ' + this.sitecore.betslip.betslipBar.Fold;
        }
    }
}
